import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiService } from '../../util/api.service';
import { HeadersRequest } from '../../util/model/header-request.inteface';
import { OrdemSolicitacao } from 'src/app/core/apis/orchestrador/model/solicitacao/ordem-solicitacao';

@Injectable({
  providedIn: 'root'
})
export class SolicitacaoService {

  public basePath = environment.basePathOrquestrador + '/serasajud-solicitacao/v1';
  // public basePath = 'http://localhost:8081/data-capture/orquestrador/v1/serasajud-solicitacao/v1';

  constructor(
    protected apiService: ApiService
  ) { }

  public saveSolicitacao(solicitacao: OrdemSolicitacao, auth: string) {
    return this.apiService.post(`${this.basePath}/ordens`, solicitacao, this.getHeaders(auth));
  }

  public getArquivoUrl(idDtDrive: string, auth: string) {
    return this.apiService.get(`${this.basePath}/ordens/${idDtDrive}/arquivo/urlDtDrive`, null, this.getHeaders(auth));
  }

  private getHeaders(auth: string): Array<HeadersRequest> {
    const headers: Array<HeadersRequest> = new Array<HeadersRequest>();
    headers.push({param: 'Authorization', value: 'Bearer ' + auth});
    return headers;
  }

}
